import React, { createContext, useContext, useEffect, useMemo, useRef, useState } from "react";
import RatesProviderStore from "@ipru-common/store/RatesProviderStore";

export const RatesContext = createContext();

export const RatesProvider = ({ children }) => {
  const [ratesInContext, setRatesInContext] = useState(null);

  const values = { ratesInContext, setRatesInContext };

  const globalRef = useRef(ratesInContext);

  useEffect(() => {
    globalRef.current = ratesInContext;
    RatesProviderStore.setSnapshot(ratesInContext);
  }, [ratesInContext]);

  return (
    <RatesContext.Provider value={useMemo(() => values, [ratesInContext, setRatesInContext])}>
      {children}
    </RatesContext.Provider>
  );
};

/**
 *
 * @returns {RatesContext}
 */
export const useRatesContext = () => {
  const context = useContext(RatesContext);
  if (!context) {
    throw new Error("useRatesContext must be used within a RatesProvider");
  }
  return context;
};
